import { AutoComplete as OriginalAutoComplete } from 'antd';
import { withWrap } from '../../utils/hoc';
const AutoComplete = withWrap(OriginalAutoComplete);
export default AutoComplete;
